<template>
  <div>
    <v-tooltip
      open-delay="100"
      top
    >
      <template
        v-slot:activator="{ on, attrs }"
      >
        <v-btn
          color="grey"
          :disabled="isFirstPage"
          small
          text
          v-bind="attrs"
          v-on="on"
          @click="$emit('select', 1)"
        >
          <v-icon
            small
          >
            first_page
          </v-icon>
        </v-btn>
      </template>
      <span>
        {{ $t('first_page') }}
      </span>
    </v-tooltip>
    <v-tooltip
      open-delay="100"
      top
    >
      <template
        v-slot:activator="{ on, attrs }"
      >
        <v-btn
          color="grey"
          :disabled="isFirstPage"
          small
          text
          v-bind="attrs"
          v-on="on"
          @click="$emit('select', page - 1)"
        >
          <v-icon
            small
          >
            navigate_before
          </v-icon>
        </v-btn>
      </template>
      <span>
        {{ $t('previous') }}
      </span>
    </v-tooltip>
    <v-btn
      v-for="(previousPage, index) in previousPages"
      :key="`previousPage.${index}`"
      color="grey"
      small
      text
      @click="$emit('select', previousPage)"
    >
      {{ previousPage }}
    </v-btn>
    <v-btn
      class="font-weight-bold"
      color="black"
      small
      text
    >
      {{ page }}
    </v-btn>
    <v-btn
      v-for="(nextPage, index) in nextPages"
      :key="`nextPage.${index}`"
      color="grey"
      small
      text
      @click="$emit('select', nextPage)"
    >
      {{ nextPage }}
    </v-btn>
    <v-tooltip
      open-delay="100"
      top
    >
      <template
        v-slot:activator="{ on, attrs }"
      >
        <v-btn
          color="grey"
          :disabled="isLastPage"
          small
          text
          v-bind="attrs"
          v-on="on"
          @click="$emit('select', page + 1)"
        >
          <v-icon
            small
          >
            navigate_next
          </v-icon>
        </v-btn>
      </template>
      <span>
        {{ $t('next') }}
      </span>
    </v-tooltip>
    <v-tooltip
      open-delay="100"
      top
    >
      <template
        v-slot:activator="{ on, attrs }"
      >
        <v-btn
          color="grey"
          :disabled="isLastPage"
          small
          text
          v-bind="attrs"
          v-on="on"
          @click="$emit('select', totalPages)"
        >
          <v-icon
            small
          >
            last_page
          </v-icon>
        </v-btn>
      </template>
      <span>
        {{ $t('last_page') }}
      </span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: 'PaginationControl',

  props: {
    offset: {
      default: 3,
      type: Number,
    },
    page: {
      required: true,
      type: [
        Number,
        String,
      ],
    },
    perPage: {
      required: true,
      type: [
        Number,
        String,
      ],
    },
    total: {
      required: true,
      type: [
        Number,
        String,
      ],
    },
  },

  computed: {
    isFirstPage () {
      return this.page === 1
    },

    isLastPage () {
      return this.totalPages === this.page
    },

    nextPages () {
      if (this.isLastPage) {
        return []
      }

      const pages = []

      for (let page = Number(this.page) + 1; page <= this.totalPages && page <= Number(this.page) + this.offset; page++) {
        pages.push(page)
      }

      return pages
    },

    previousPages () {
      if (this.isFirstPage) {
        return []
      }

      const pages = []

      for (let page = Number(this.page) - 1; page > 0 && page >= Number(this.page) - this.offset; page--) {
        pages.push(page)
      }

      return pages.sort((a, b) => a - b)
    },

    totalPages () {
      return Math.ceil(this.total / this.perPage) || 1
    },
  },
}
</script>
